"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: auth/account-closure.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fauth%2Faccount-closure.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountClosureReasonToJSON = exports.accountClosureReasonFromJSON = exports.accountClosureSourceToJSON = exports.accountClosureSourceFromJSON = exports.accountClosureTypeToJSON = exports.accountClosureTypeFromJSON = exports.AccountClosure = exports.AccountClosureReason = exports.AccountClosureSource = exports.AccountClosureType = void 0;
const protobufPackage = 'com.step.auth.proto';
/**
 * Type of account closure.
 */
var AccountClosureType;
(function (AccountClosureType) {
    AccountClosureType["INVALID_ACCOUNT_CLOSURE_TYPE"] = "INVALID_ACCOUNT_CLOSURE_TYPE";
    AccountClosureType["COMPLIANCE"] = "COMPLIANCE";
    AccountClosureType["FRAUD"] = "FRAUD";
    AccountClosureType["FRIENDLY"] = "FRIENDLY";
    AccountClosureType["DELINQUENT_ACCOUNT"] = "DELINQUENT_ACCOUNT";
    AccountClosureType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AccountClosureType || (exports.AccountClosureType = AccountClosureType = {}));
/**
 * The source of account closure originating a request.
 */
var AccountClosureSource;
(function (AccountClosureSource) {
    AccountClosureSource["INVALID_ACCOUNT_CLOSURE_SOURCE"] = "INVALID_ACCOUNT_CLOSURE_SOURCE";
    /**
     * ADMIN - From admin UI.
     */
    AccountClosureSource["ADMIN"] = "ADMIN";
    /**
     * JOB - From intercom via admin queue.
     */
    AccountClosureSource["JOB"] = "JOB";
    /**
     * CLIENT - From the mobile app.
     */
    AccountClosureSource["CLIENT"] = "CLIENT";
    /**
     * ML - By ML-based decision.
     */
    AccountClosureSource["ML"] = "ML";
    AccountClosureSource["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AccountClosureSource || (exports.AccountClosureSource = AccountClosureSource = {}));
/**
 * Reason why an account was closed.
 */
var AccountClosureReason;
(function (AccountClosureReason) {
    /**
     * INVALID_ACCOUNT_CLOSURE_REASON - Undefined
     */
    AccountClosureReason["INVALID_ACCOUNT_CLOSURE_REASON"] = "INVALID_ACCOUNT_CLOSURE_REASON";
    /**
     * COMPLIANCE_HIGH_RISK - Compliance - High Risk
     */
    AccountClosureReason["COMPLIANCE_HIGH_RISK"] = "COMPLIANCE_HIGH_RISK";
    /**
     * UNRESPONSIVE - Compliance - Non-response to information request
     */
    AccountClosureReason["UNRESPONSIVE"] = "UNRESPONSIVE";
    /**
     * FRAUD_HIGH_RISK - Fraud - High Risk User / High Risk Transactions
     */
    AccountClosureReason["FRAUD_HIGH_RISK"] = "FRAUD_HIGH_RISK";
    /**
     * IDENTIFY_THEFT - Fraud - Identity Theft
     */
    AccountClosureReason["IDENTIFY_THEFT"] = "IDENTIFY_THEFT";
    /**
     * FUNDING_FRAUD - Fraud - Funding Fraud
     */
    AccountClosureReason["FUNDING_FRAUD"] = "FUNDING_FRAUD";
    /**
     * DOCUMENT_NOT_PROVIDED - Fraud - Non-response to document request
     */
    AccountClosureReason["DOCUMENT_NOT_PROVIDED"] = "DOCUMENT_NOT_PROVIDED";
    /**
     * REFERRAL_ABUSE - Fraud - Referral Abuse/Multiple Account
     */
    AccountClosureReason["REFERRAL_ABUSE"] = "REFERRAL_ABUSE";
    /**
     * CHARGEBACK_ABUSE - Fraud - Chargeback Abuse
     */
    AccountClosureReason["CHARGEBACK_ABUSE"] = "CHARGEBACK_ABUSE";
    /**
     * FALSIFIED_DOCUMENTS - Fraud - Falsified documents
     */
    AccountClosureReason["FALSIFIED_DOCUMENTS"] = "FALSIFIED_DOCUMENTS";
    /**
     * DUPLICATE_ACCOUNT - Friendly - Duplicate Account
     */
    AccountClosureReason["DUPLICATE_ACCOUNT"] = "DUPLICATE_ACCOUNT";
    /**
     * RESET_ACCOUNT - Friendly - Reset Account (signed up with wrong info)
     */
    AccountClosureReason["RESET_ACCOUNT"] = "RESET_ACCOUNT";
    /**
     * TURNED_18 - Friendly - User turned 18
     */
    AccountClosureReason["TURNED_18"] = "TURNED_18";
    /**
     * DONT_WANT_ANYMORE - Friendly - Don't want account anymore
     */
    AccountClosureReason["DONT_WANT_ANYMORE"] = "DONT_WANT_ANYMORE";
    /**
     * ACCOUNT_TAKEOVER - Fraud - Account Takeover
     */
    AccountClosureReason["ACCOUNT_TAKEOVER"] = "ACCOUNT_TAKEOVER";
    /**
     * CHARGEBACKS_RETURNS - Fraud - Chargebacks / Returns
     */
    AccountClosureReason["CHARGEBACKS_RETURNS"] = "CHARGEBACKS_RETURNS";
    /**
     * PARENT_TEEN_CLOSURE - Friendly - Parent & Teen Closure
     */
    AccountClosureReason["PARENT_TEEN_CLOSURE"] = "PARENT_TEEN_CLOSURE";
    /**
     * UNDER_13 - Compliance - Under 13
     */
    AccountClosureReason["UNDER_13"] = "UNDER_13";
    /**
     * WONT_SEND_DOCS - Friendly - Won't submit docs for KYC
     */
    AccountClosureReason["WONT_SEND_DOCS"] = "WONT_SEND_DOCS";
    /**
     * COMPLIANCE_KYC_FAILED - Compliance - Failed KYC
     */
    AccountClosureReason["COMPLIANCE_KYC_FAILED"] = "COMPLIANCE_KYC_FAILED";
    /**
     * FRAUD_KYC_FAILED - Fraud - Failed KYC
     */
    AccountClosureReason["FRAUD_KYC_FAILED"] = "FRAUD_KYC_FAILED";
    /**
     * ABUSIVE - Fraud - Abusive (communication)
     */
    AccountClosureReason["ABUSIVE"] = "ABUSIVE";
    /**
     * MANAGED_USER_GRADUATION - Friendly - Managed user graduation
     */
    AccountClosureReason["MANAGED_USER_GRADUATION"] = "MANAGED_USER_GRADUATION";
    /**
     * FIRST_PARTY_FRAUD - Fraud - First-party chargeback abuse
     */
    AccountClosureReason["FIRST_PARTY_FRAUD"] = "FIRST_PARTY_FRAUD";
    /**
     * UNAUTHORIZED_FAMILY_USE - Fraud - Unauthorized Family/Sponsor use
     */
    AccountClosureReason["UNAUTHORIZED_FAMILY_USE"] = "UNAUTHORIZED_FAMILY_USE";
    /**
     * SPENDING_ACCOUNT_PAST_DUE - Delinquent - Payment past due for spending account
     */
    AccountClosureReason["SPENDING_ACCOUNT_PAST_DUE"] = "SPENDING_ACCOUNT_PAST_DUE";
    /**
     * OVERDRAFT_PROTECTION_PAST_DUE - Delinquent - Overdraft protection payment past due
     */
    AccountClosureReason["OVERDRAFT_PROTECTION_PAST_DUE"] = "OVERDRAFT_PROTECTION_PAST_DUE";
    /**
     * BNPL_PAST_DUE - Delinquent - BNPL payment past due
     */
    AccountClosureReason["BNPL_PAST_DUE"] = "BNPL_PAST_DUE";
    /**
     * FLEX_PAST_DUE - Delinquent - Flex bill payment past due
     */
    AccountClosureReason["FLEX_PAST_DUE"] = "FLEX_PAST_DUE";
    /**
     * USER_NOT_USING_PRODUCT - Friendly - Not using the product
     */
    AccountClosureReason["USER_NOT_USING_PRODUCT"] = "USER_NOT_USING_PRODUCT";
    /**
     * USER_UNRECOGNIZED_CHARGES - Friendly - Unrecognized charges
     */
    AccountClosureReason["USER_UNRECOGNIZED_CHARGES"] = "USER_UNRECOGNIZED_CHARGES";
    /**
     * USER_CANT_CANCEL_SUBSCRIPTION - Friendly - Can't figure how to cancel a recurring subscription
     */
    AccountClosureReason["USER_CANT_CANCEL_SUBSCRIPTION"] = "USER_CANT_CANCEL_SUBSCRIPTION";
    /**
     * USER_CANT_UPDATE_ACCOUNT - Friendly - Update account details
     */
    AccountClosureReason["USER_CANT_UPDATE_ACCOUNT"] = "USER_CANT_UPDATE_ACCOUNT";
    /**
     * USER_NEED_MORE_FEATURES - Friendly - Step features don't meet my banking needs
     */
    AccountClosureReason["USER_NEED_MORE_FEATURES"] = "USER_NEED_MORE_FEATURES";
    /**
     * USER_LIMITS_TOO_LOW - Friendly - Step limits are too low
     */
    AccountClosureReason["USER_LIMITS_TOO_LOW"] = "USER_LIMITS_TOO_LOW";
    /**
     * USER_TECHNICAL_ISSUES - Friendly - Having technical issues and can't use the account
     */
    AccountClosureReason["USER_TECHNICAL_ISSUES"] = "USER_TECHNICAL_ISSUES";
    /**
     * USER_COMPETING_PRODUCT - Friendly - Switching to a new bank or app
     */
    AccountClosureReason["USER_COMPETING_PRODUCT"] = "USER_COMPETING_PRODUCT";
    /**
     * USER_OTHER_REASON - Friendly - Close for another reason
     */
    AccountClosureReason["USER_OTHER_REASON"] = "USER_OTHER_REASON";
    /**
     * USER_CANNOT_BORROW_MONEY - Friendly - cannot borrow money
     */
    AccountClosureReason["USER_CANNOT_BORROW_MONEY"] = "USER_CANNOT_BORROW_MONEY";
    AccountClosureReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AccountClosureReason || (exports.AccountClosureReason = AccountClosureReason = {}));
function createBaseAccountClosure() {
    return {
        type: AccountClosureType.INVALID_ACCOUNT_CLOSURE_TYPE,
        reason: AccountClosureReason.INVALID_ACCOUNT_CLOSURE_REASON,
    };
}
exports.AccountClosure = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? accountClosureTypeFromJSON(object.type)
                : AccountClosureType.INVALID_ACCOUNT_CLOSURE_TYPE,
            reason: isSet(object.reason)
                ? accountClosureReasonFromJSON(object.reason)
                : AccountClosureReason.INVALID_ACCOUNT_CLOSURE_REASON,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== AccountClosureType.INVALID_ACCOUNT_CLOSURE_TYPE) {
            obj.type = accountClosureTypeToJSON(message.type);
        }
        if (message.reason !== AccountClosureReason.INVALID_ACCOUNT_CLOSURE_REASON) {
            obj.reason = accountClosureReasonToJSON(message.reason);
        }
        return obj;
    },
    create(base) {
        return exports.AccountClosure.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountClosure();
        message.type = object.type ?? AccountClosureType.INVALID_ACCOUNT_CLOSURE_TYPE;
        message.reason = object.reason ?? AccountClosureReason.INVALID_ACCOUNT_CLOSURE_REASON;
        return message;
    },
};
function accountClosureTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ACCOUNT_CLOSURE_TYPE':
            return AccountClosureType.INVALID_ACCOUNT_CLOSURE_TYPE;
        case 1:
        case 'COMPLIANCE':
            return AccountClosureType.COMPLIANCE;
        case 2:
        case 'FRAUD':
            return AccountClosureType.FRAUD;
        case 3:
        case 'FRIENDLY':
            return AccountClosureType.FRIENDLY;
        case 4:
        case 'DELINQUENT_ACCOUNT':
            return AccountClosureType.DELINQUENT_ACCOUNT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AccountClosureType.UNRECOGNIZED;
    }
}
exports.accountClosureTypeFromJSON = accountClosureTypeFromJSON;
function accountClosureTypeToJSON(object) {
    switch (object) {
        case AccountClosureType.INVALID_ACCOUNT_CLOSURE_TYPE:
            return 'INVALID_ACCOUNT_CLOSURE_TYPE';
        case AccountClosureType.COMPLIANCE:
            return 'COMPLIANCE';
        case AccountClosureType.FRAUD:
            return 'FRAUD';
        case AccountClosureType.FRIENDLY:
            return 'FRIENDLY';
        case AccountClosureType.DELINQUENT_ACCOUNT:
            return 'DELINQUENT_ACCOUNT';
        case AccountClosureType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.accountClosureTypeToJSON = accountClosureTypeToJSON;
function accountClosureSourceFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ACCOUNT_CLOSURE_SOURCE':
            return AccountClosureSource.INVALID_ACCOUNT_CLOSURE_SOURCE;
        case 1:
        case 'ADMIN':
            return AccountClosureSource.ADMIN;
        case 2:
        case 'JOB':
            return AccountClosureSource.JOB;
        case 3:
        case 'CLIENT':
            return AccountClosureSource.CLIENT;
        case 4:
        case 'ML':
            return AccountClosureSource.ML;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AccountClosureSource.UNRECOGNIZED;
    }
}
exports.accountClosureSourceFromJSON = accountClosureSourceFromJSON;
function accountClosureSourceToJSON(object) {
    switch (object) {
        case AccountClosureSource.INVALID_ACCOUNT_CLOSURE_SOURCE:
            return 'INVALID_ACCOUNT_CLOSURE_SOURCE';
        case AccountClosureSource.ADMIN:
            return 'ADMIN';
        case AccountClosureSource.JOB:
            return 'JOB';
        case AccountClosureSource.CLIENT:
            return 'CLIENT';
        case AccountClosureSource.ML:
            return 'ML';
        case AccountClosureSource.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.accountClosureSourceToJSON = accountClosureSourceToJSON;
function accountClosureReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ACCOUNT_CLOSURE_REASON':
            return AccountClosureReason.INVALID_ACCOUNT_CLOSURE_REASON;
        case 1:
        case 'COMPLIANCE_HIGH_RISK':
            return AccountClosureReason.COMPLIANCE_HIGH_RISK;
        case 2:
        case 'UNRESPONSIVE':
            return AccountClosureReason.UNRESPONSIVE;
        case 4:
        case 'FRAUD_HIGH_RISK':
            return AccountClosureReason.FRAUD_HIGH_RISK;
        case 5:
        case 'IDENTIFY_THEFT':
            return AccountClosureReason.IDENTIFY_THEFT;
        case 6:
        case 'FUNDING_FRAUD':
            return AccountClosureReason.FUNDING_FRAUD;
        case 7:
        case 'DOCUMENT_NOT_PROVIDED':
            return AccountClosureReason.DOCUMENT_NOT_PROVIDED;
        case 8:
        case 'REFERRAL_ABUSE':
            return AccountClosureReason.REFERRAL_ABUSE;
        case 9:
        case 'CHARGEBACK_ABUSE':
            return AccountClosureReason.CHARGEBACK_ABUSE;
        case 11:
        case 'FALSIFIED_DOCUMENTS':
            return AccountClosureReason.FALSIFIED_DOCUMENTS;
        case 13:
        case 'DUPLICATE_ACCOUNT':
            return AccountClosureReason.DUPLICATE_ACCOUNT;
        case 17:
        case 'RESET_ACCOUNT':
            return AccountClosureReason.RESET_ACCOUNT;
        case 19:
        case 'TURNED_18':
            return AccountClosureReason.TURNED_18;
        case 20:
        case 'DONT_WANT_ANYMORE':
            return AccountClosureReason.DONT_WANT_ANYMORE;
        case 21:
        case 'ACCOUNT_TAKEOVER':
            return AccountClosureReason.ACCOUNT_TAKEOVER;
        case 22:
        case 'CHARGEBACKS_RETURNS':
            return AccountClosureReason.CHARGEBACKS_RETURNS;
        case 23:
        case 'PARENT_TEEN_CLOSURE':
            return AccountClosureReason.PARENT_TEEN_CLOSURE;
        case 24:
        case 'UNDER_13':
            return AccountClosureReason.UNDER_13;
        case 25:
        case 'WONT_SEND_DOCS':
            return AccountClosureReason.WONT_SEND_DOCS;
        case 26:
        case 'COMPLIANCE_KYC_FAILED':
            return AccountClosureReason.COMPLIANCE_KYC_FAILED;
        case 27:
        case 'FRAUD_KYC_FAILED':
            return AccountClosureReason.FRAUD_KYC_FAILED;
        case 28:
        case 'ABUSIVE':
            return AccountClosureReason.ABUSIVE;
        case 29:
        case 'MANAGED_USER_GRADUATION':
            return AccountClosureReason.MANAGED_USER_GRADUATION;
        case 30:
        case 'FIRST_PARTY_FRAUD':
            return AccountClosureReason.FIRST_PARTY_FRAUD;
        case 31:
        case 'UNAUTHORIZED_FAMILY_USE':
            return AccountClosureReason.UNAUTHORIZED_FAMILY_USE;
        case 32:
        case 'SPENDING_ACCOUNT_PAST_DUE':
            return AccountClosureReason.SPENDING_ACCOUNT_PAST_DUE;
        case 33:
        case 'OVERDRAFT_PROTECTION_PAST_DUE':
            return AccountClosureReason.OVERDRAFT_PROTECTION_PAST_DUE;
        case 34:
        case 'BNPL_PAST_DUE':
            return AccountClosureReason.BNPL_PAST_DUE;
        case 35:
        case 'FLEX_PAST_DUE':
            return AccountClosureReason.FLEX_PAST_DUE;
        case 36:
        case 'USER_NOT_USING_PRODUCT':
            return AccountClosureReason.USER_NOT_USING_PRODUCT;
        case 37:
        case 'USER_UNRECOGNIZED_CHARGES':
            return AccountClosureReason.USER_UNRECOGNIZED_CHARGES;
        case 38:
        case 'USER_CANT_CANCEL_SUBSCRIPTION':
            return AccountClosureReason.USER_CANT_CANCEL_SUBSCRIPTION;
        case 39:
        case 'USER_CANT_UPDATE_ACCOUNT':
            return AccountClosureReason.USER_CANT_UPDATE_ACCOUNT;
        case 40:
        case 'USER_NEED_MORE_FEATURES':
            return AccountClosureReason.USER_NEED_MORE_FEATURES;
        case 41:
        case 'USER_LIMITS_TOO_LOW':
            return AccountClosureReason.USER_LIMITS_TOO_LOW;
        case 42:
        case 'USER_TECHNICAL_ISSUES':
            return AccountClosureReason.USER_TECHNICAL_ISSUES;
        case 43:
        case 'USER_COMPETING_PRODUCT':
            return AccountClosureReason.USER_COMPETING_PRODUCT;
        case 44:
        case 'USER_OTHER_REASON':
            return AccountClosureReason.USER_OTHER_REASON;
        case 45:
        case 'USER_CANNOT_BORROW_MONEY':
            return AccountClosureReason.USER_CANNOT_BORROW_MONEY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AccountClosureReason.UNRECOGNIZED;
    }
}
exports.accountClosureReasonFromJSON = accountClosureReasonFromJSON;
function accountClosureReasonToJSON(object) {
    switch (object) {
        case AccountClosureReason.INVALID_ACCOUNT_CLOSURE_REASON:
            return 'INVALID_ACCOUNT_CLOSURE_REASON';
        case AccountClosureReason.COMPLIANCE_HIGH_RISK:
            return 'COMPLIANCE_HIGH_RISK';
        case AccountClosureReason.UNRESPONSIVE:
            return 'UNRESPONSIVE';
        case AccountClosureReason.FRAUD_HIGH_RISK:
            return 'FRAUD_HIGH_RISK';
        case AccountClosureReason.IDENTIFY_THEFT:
            return 'IDENTIFY_THEFT';
        case AccountClosureReason.FUNDING_FRAUD:
            return 'FUNDING_FRAUD';
        case AccountClosureReason.DOCUMENT_NOT_PROVIDED:
            return 'DOCUMENT_NOT_PROVIDED';
        case AccountClosureReason.REFERRAL_ABUSE:
            return 'REFERRAL_ABUSE';
        case AccountClosureReason.CHARGEBACK_ABUSE:
            return 'CHARGEBACK_ABUSE';
        case AccountClosureReason.FALSIFIED_DOCUMENTS:
            return 'FALSIFIED_DOCUMENTS';
        case AccountClosureReason.DUPLICATE_ACCOUNT:
            return 'DUPLICATE_ACCOUNT';
        case AccountClosureReason.RESET_ACCOUNT:
            return 'RESET_ACCOUNT';
        case AccountClosureReason.TURNED_18:
            return 'TURNED_18';
        case AccountClosureReason.DONT_WANT_ANYMORE:
            return 'DONT_WANT_ANYMORE';
        case AccountClosureReason.ACCOUNT_TAKEOVER:
            return 'ACCOUNT_TAKEOVER';
        case AccountClosureReason.CHARGEBACKS_RETURNS:
            return 'CHARGEBACKS_RETURNS';
        case AccountClosureReason.PARENT_TEEN_CLOSURE:
            return 'PARENT_TEEN_CLOSURE';
        case AccountClosureReason.UNDER_13:
            return 'UNDER_13';
        case AccountClosureReason.WONT_SEND_DOCS:
            return 'WONT_SEND_DOCS';
        case AccountClosureReason.COMPLIANCE_KYC_FAILED:
            return 'COMPLIANCE_KYC_FAILED';
        case AccountClosureReason.FRAUD_KYC_FAILED:
            return 'FRAUD_KYC_FAILED';
        case AccountClosureReason.ABUSIVE:
            return 'ABUSIVE';
        case AccountClosureReason.MANAGED_USER_GRADUATION:
            return 'MANAGED_USER_GRADUATION';
        case AccountClosureReason.FIRST_PARTY_FRAUD:
            return 'FIRST_PARTY_FRAUD';
        case AccountClosureReason.UNAUTHORIZED_FAMILY_USE:
            return 'UNAUTHORIZED_FAMILY_USE';
        case AccountClosureReason.SPENDING_ACCOUNT_PAST_DUE:
            return 'SPENDING_ACCOUNT_PAST_DUE';
        case AccountClosureReason.OVERDRAFT_PROTECTION_PAST_DUE:
            return 'OVERDRAFT_PROTECTION_PAST_DUE';
        case AccountClosureReason.BNPL_PAST_DUE:
            return 'BNPL_PAST_DUE';
        case AccountClosureReason.FLEX_PAST_DUE:
            return 'FLEX_PAST_DUE';
        case AccountClosureReason.USER_NOT_USING_PRODUCT:
            return 'USER_NOT_USING_PRODUCT';
        case AccountClosureReason.USER_UNRECOGNIZED_CHARGES:
            return 'USER_UNRECOGNIZED_CHARGES';
        case AccountClosureReason.USER_CANT_CANCEL_SUBSCRIPTION:
            return 'USER_CANT_CANCEL_SUBSCRIPTION';
        case AccountClosureReason.USER_CANT_UPDATE_ACCOUNT:
            return 'USER_CANT_UPDATE_ACCOUNT';
        case AccountClosureReason.USER_NEED_MORE_FEATURES:
            return 'USER_NEED_MORE_FEATURES';
        case AccountClosureReason.USER_LIMITS_TOO_LOW:
            return 'USER_LIMITS_TOO_LOW';
        case AccountClosureReason.USER_TECHNICAL_ISSUES:
            return 'USER_TECHNICAL_ISSUES';
        case AccountClosureReason.USER_COMPETING_PRODUCT:
            return 'USER_COMPETING_PRODUCT';
        case AccountClosureReason.USER_OTHER_REASON:
            return 'USER_OTHER_REASON';
        case AccountClosureReason.USER_CANNOT_BORROW_MONEY:
            return 'USER_CANNOT_BORROW_MONEY';
        case AccountClosureReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.accountClosureReasonToJSON = accountClosureReasonToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=account-closure.js.map